<template>
  <div class="search-edit">
    <div :class="{'abs-center-container':true, 'show-on-load':showOnLoad}">
      <div class="abs-center">
        <div class="card medium-margin-v-s">
          <h3 class="margin-t-z margin-b-s">{{ $t('searchEdit.editCancel') }}</h3>
          <div class="description">{{ $t('searchEdit.followInfo') }}:</div>
          <form @submit.prevent="submit">
            <div class="row">
              <div class="large-4 column ">
                <div v-bind:class="['field-group' + ( validation.rsvpNumber ? '': ' field-error')]">
                  <input class="field-text" ref="ReservationNumberInput" type="text" v-model="rsvpNumber"
                    :placeholder="$t('searchEdit.rsvpNumber')" @keypress="validation.rsvpNumber = true" />
                  <label class="field-error-message">
                    {{ $t('searchEdit.isRequired') }}
                  </label>
                </div>
              </div>
              <div class="large-4 column padding-l-s medium-padding-h-z">
                <div :class="['field-group', {'field-error':!validation.firstName}]">
                  <input class="field-text" type="text" v-model="firstName" :placeholder="$t('searchEdit.firstName')" @keypress="validation.firstName = true" />
                  <label class="field-error-message">
                    {{ $t('searchEdit.isRequired') }}
                  </label>
                </div>
              </div>
              <div class="large-4 column padding-l-s medium-padding-h-z">
                <div :class="['field-group', {'field-error':!validation.lastName}]">
                  <input class="field-text" type="text" v-model="lastName" :placeholder="$t('searchEdit.lastName')" @keypress="validation.lastName = true" />
                  <label class="field-error-message">
                    {{ $t('searchEdit.isRequired') }}
                  </label>
                </div>
              </div>
            </div>
            <div :class="['error-message', {hide: !error.show}]">{{ error.message }}</div>
            <div class="controls">
              <a href="#/search" class="op-btn btn-lg" @click="cancel($event)">{{ $t('common.cancel') }}</a>
              <a href="#/rsvp-edit" :class="['op-btn btn-success btn-lg btn-continue', {disabled: isSearching}]"
                @click="submitEdit($event)">
                <i class="fa fa-spinner fa-spin" v-show="isSearching"></i>
                <span v-show="!isSearching">{{ $t('common.continue') }}</span>
              </a>
              <button type="submit" ref="submitBtn" v-show="false"></button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <unassign-driver></unassign-driver>
</div>
</template>

<script type="text/javascript">
/* global CONFIG */
import moment from 'moment'
import UnassignDriver from './UnassignDriver'
import ft from '@/modules/api/featureToggle'
import ApiRsvpSearch from '@/modules/api/reservation-search'

export default {
  name: 'search-edit',
  components: { UnassignDriver },
  data () {
    return {
      rsvpNumber: '',
      firstName: '',
      lastName: '',
      isSearching: false,
      validation: {
        rsvpNumber: true,
        firstName: true,
        lastName: true
      },
      error: {
        show: false,
        message: ''
      },
      showOnLoad: false
    }
  },
  computed: {
    _brandId () { return this.$store.state.brandId },
    route () { return this.$route.name }
  },
  methods: {
    cancel (event) {
      if (event) event.preventDefault()
      // let loc = window.location.href
      // let index = loc.indexOf('#')
      // window.location = loc.substring(0, index) + '#'

      this.$store.commit('reservation/setCharterData', {
        enabled: false,
        pickup: {},
        startDate: '',
        endDate: '',
        selectedService: ''
      })

      this.$root.$emit('close')
      this.$root.$router.push('search')
      window.location.href = '#/search'
    },
    onKeyPress () {
    },
    isValid () {
      let self = this
      self.validation.rsvpNumber = true
      self.validation.firstName = true
      self.validation.lastName = true
      let result = true
      if (self.rsvpNumber === '') {
        self.validation.rsvpNumber = false
        result = false
      }
      if (self.firstName === '') {
        self.validation.firstName = false
        result = false
      }
      if (self.lastName === '') {
        self.validation.lastName = false
        result = false
      }
      return result
    },
    submit () {
      let self = this
      self.error = {
        show: false,
        message: ''
      }
      if (!self.isValid()) {
        return
      }

      self.isSearching = true

      ApiRsvpSearch.search(self, self.rsvpNumber, self.firstName, self.lastName, rsvp => {
        self.isSearching = false
        let brandData = Object.values(CONFIG.Brands).find((v) => {
          return v.code === 'bh'
        })
        self.$store.commit('reservation/setMtechData', {enabled: rsvp.isMtech || false})
        if (rsvp.brandID !== self.$store.state.brandId && rsvp.brandID !== brandData.id) {
          self.error = {
            show: true,
            message: self.$t('searchEdit.cannotFind')
          }
          return
        }

        if (rsvp.dispatchStatus === 'complete') {
          self.error = {
            show: true,
            message: self.$t('searchEdit.rsvpCompleted')
          }
          return
        }

        if (rsvp.dispatchStatus === 'canceled') {
          self.error = {
            show: true,
            message: self.$t('searchEdit.rsvpCancelled')
          }
          return
        }

        if (rsvp.dispatchStatus === 'ontheway') {
          self.error = {
            show: true,
            message: self.$t('searchEdit.cannotEdit')
          }
          return
        }

        if (rsvp.dispatchStatus === 'onboard') {
          self.error = {
            show: true,
            message: self.$t('searchEdit.onboard')
          }
          return
        }

        if (rsvp.provider.ID !== null && rsvp.provider.ID !== '') {
          self.$store.commit('rsvpEdit/setUnassignRsvp', {
            id: self.rsvpNumber,
            firstName: self.firstName,
            lastName: self.lastName
          })
          self.$store.commit('rsvpEdit/showUnassignDriver')
          return
        }

        if (rsvp.hasExtraStop) {
          self.$sdk.get(self, `/reservations/${self.rsvpNumber}/${self.firstName}/${self.lastName}/extrastops`, {}, res => {
            if (!res.error) {
              rsvp.extraStops = res.list
              self.proceedToEdit(rsvp)
            }
          }, '1.1')
        } else {
          this.$store.commit('reservation/setCharterData', {
            enabled: false,
            pickup: {},
            startDate: '',
            endDate: '',
            selectedService: ''
          })
          if (rsvp.isCharter) {
            let starDate = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + ft.timeFormat(self, false))
            self.$store.commit('reservation/setCharterData', {
              enabled: true,
              pickup: rsvp.pickup,
              startDate: starDate.format('MM/DD/YYYY hh:mmA'),
              endDate: starDate.add(rsvp.eta, 'seconds').format('MM/DD/YYYY hh:mmA'),
              selectedService: rsvp.serviceCode
            })
          }
          if (rsvp.discountCode && rsvp.isCorporate) {
            self.$root.$emit('redeemCode', {code: rsvp.discountCode})
          }
          self.proceedToEdit(rsvp)
        }
      }, error => {
        self.isSearching = false
        self.error = {
          show: true,
          message: self.$t('searchEdit.rsvpDoesntExist')
        }
        console.log(error)
      })
    },
    proceedToEdit (rsvp) {
      let self = this
      self.$store.commit('rsvpEdit/setOriginalRsvp', rsvp)
      self.$store.commit('rsvpEdit/setEditedRsvp', Object.assign({}, rsvp))
      // self.$router.push('rsvp-edit')
      if (self.showOnLoad) {
        document.body.classList.add('widget-full');
      }

      if (window.opoliCNS) {
        let segment = {
          key: 'HomePage_Edit',
          'Reservation Number': self.rsvpNumber,
          'First Name': self.firstName,
          'Last name': self.lastName
        }
        window.opoliCNS('events', {
          key: 'HomePage_Edit',
          segment: segment,
          url: null,
          widgetEvent: true
        })
      }

      this.$root.$router.push('rsvp-edit')
      window.location.href = '#/rsvp-edit'
    },
    checkShowOnLoad () {
      let brandData = Object.values(CONFIG.Brands).find((v) => {
        return parseInt(this._brandId, 10) === parseInt(v.id, 10)
      }) || false
      let firstPage = ['Search', 'SearchEdit', 'SearchTrack']
      document.body.classList.remove('widget-full')
      if (brandData) {
        this.showOnLoad = brandData.showOnLoad && firstPage.indexOf(this.route) > -1 ? 'show-on-load' : ''
      }
    },
    submitEdit (event) {
      if (event) event.preventDefault()
      if (this.$refs.submitBtn) {
        this.$refs.submitBtn.click()
      }
    }
  },
  watch: {
    _brandId: function (value) { this.checkShowOnLoad() }
  },
  mounted () {
    this.checkShowOnLoad()
    this.$store.commit('setCurrentIndex', -1)
    this.$refs.ReservationNumberInput.focus()

    window.dispatchEvent(new HashChangeEvent('hashchange'))
  }
}
</script>

<style lang="scss" scoped>
.abs-center-container {
  position: fixed;
  display: table;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  & .abs-center{
    display: table-cell;
    vertical-align: middle;
  }
  &.show-on-load{
    position: relative;
    display: block;
    text-align: left;

    .abs-center{ display: block; }
    .card{
      padding: 30px;
      border: none;
      box-shadow: none;
    }
  }
}

.card {
  max-width: 62.5rem;
  margin: 0 auto;
  border-radius: 3px;

  & h2 {
    font-size: 22px;
  }
}

.description {
  margin-bottom: 10px;
}

.error-message {
  background-color: #EB5837;
  color: #fff;
  padding: 5px;
  text-align: center;
  overflow: 0;
  transition: all 250ms;
  -webkit-transition: all 250ms;

  &.hide {
    height: 0;
    padding: 0 5px;
  }
}

.controls {
  margin-top: 10px;
  text-align: right;

  & .op-btn {
    width: 115px;
    height: 51px;
    text-align: center;
    vertical-align: middle;
  }

  & .btn-continue {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6fca4fac